import React from 'react'

import FormattedPrice from 'src/shared/components/common/price/FormattedPrice'

export type DiscountedPriceProps = {
  originalAmount: number
  amount: number
  amountPrefix?: string
  testIdPrefix: string
}

// Trailing zeros on both halves: "$6" struck beside "$0.00" reads as a typo.
const DiscountedPrice = ({
  originalAmount,
  amount,
  amountPrefix = '',
  testIdPrefix
}: DiscountedPriceProps) => (
  <span className='priceComparison'>
    <span
      className='originalAmount'
      data-testid={`${testIdPrefix}-original-amount`}
    >
      <FormattedPrice value={originalAmount} trailingZeros />
    </span>
    <span className='discountedAmount' data-testid={`${testIdPrefix}-amount`}>
      {amountPrefix}
      <FormattedPrice value={amount} trailingZeros />
    </span>
  </span>
)

export default DiscountedPrice
